import React, { useEffect } from "react";
import moment from "moment";
import { GeneralTable } from "../GeneralComponents/GeneralTable";
import { useModalAlert } from "../GeneralComponents";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  centeredCell: {
    display: "flex",
    alignItems: "start", // Vertical centering
    whiteSpace: "pre-wrap", // Tries to keep the text on a single line
    overflow: "hidden", // Hides overflow if it's on one line
    textOverflow: "ellipsis", // Adds '...' if the text is truncated
    lineHeight: "normal", // Ensure standard line height
  },
});

export function DocumentarySeries() {
  const classes = useStyles();
  const [serie, setSerie] = React.useState(null);
  const [series, setSeries] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(5);
  const [rowCount, setRowCount] = React.useState(0);

  const { showModalAlert } = useModalAlert();

  useEffect(() => {
    listSeries();
  }, [page, pageSize]);

  const columns = [
    {
      field: "codigo",
      headerName: "CÓDIGO",
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "descripcion",
      headerName: "NOMBRE DE LA SERIE",
      type: "string",
      flex: 2,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => (
        <div className={classes.centeredCell} style={{ width: "100%" }}>
          {params.value}
        </div>
      ),
    },
    {
      field: "fecha_creacion",
      headerName: "FECHA CREACIÓN",
      type: "date",
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
      valueFormatter: (params) =>
        params.value ? moment(params.value).format("DD/MM/YYYY") : "",
    },
    {
      field: "estado",
      headerName: "ESTADO",
      type: "string",
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
      valueGetter: (params) =>
        params.value != null
          ? params.value === "A"
            ? "Activa"
            : "Inactiva"
          : "No aplica",
    },
  ];

  const newModalField = [
    {
      name: "fecha_creacion",
      label: "Fecha de Creación",
      type: "date",
    },
    { name: "codigo", label: "Código", type: "text" },
    { name: "descripcion", label: "Nombre de la serie", type: "text" },
  ];

  const requiredFields = ["codigo", "descripcion"];

  const listSeries = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        `series/listar?page=${page + 1}&page_size=${pageSize}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("lista de series", data);
        
        setSeries(data.results);
        setRowCount(data.count);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const handlePageSizeChange = (pageSize) => {
    setPageSize(pageSize);
  };

  async function handleSaveNewSerie(formData) {
    let usuario = JSON.parse(sessionStorage.getItem("usuario"));
    let datos = {
      ...formData,
      id_usuario: usuario.id_usuario,
    };
    try {
      const updateResponse = await fetch(
        process.env.REACT_APP_PUBLIC_URL + "series/create",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
          body: JSON.stringify(datos),
        }
      );
      const result = await updateResponse.json();
      listSeries();
      showModalAlert("success", "Se creo correctamente la serie");
    } catch (error) {
      showModalAlert("danger", "Error al crear la serie");
    }
  }

  const onActivate = async (row) => {
    try {
      let usuario = JSON.parse(sessionStorage.getItem("usuario"));
      let dataSend = {
        id_gd_series: row.id_gd_series,
        id_usuario: usuario.id_usuario,
      };
      await fetch(process.env.REACT_APP_PUBLIC_URL + "series/activar", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataSend),
      });
      listSeries();
      showModalAlert("success", "Se activo correctamente la serie");
    } catch (error) {
      showModalAlert("danger", "Error al activar la serie");
    }
  };
  const onInactivate = async (row) => {
    try {
      let usuario = JSON.parse(sessionStorage.getItem("usuario"));
      let dataSend = {
        id_gd_series: row.id_gd_series,
        id_usuario: usuario.id_usuario,
      };
      await fetch(process.env.REACT_APP_PUBLIC_URL + "series/inactivar", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataSend),
      });
      listSeries();
      showModalAlert("success", "Se inactivo correctamente la serie");
    } catch (error) {
      showModalAlert("danger", "Error al inactivar la serie");
    }
  };

  return (
    <>
      <GeneralTable
        title="Series Documentales"
        titleAlert="Serie Documental"
        buttonText="Crear Serie"
        columns={columns}
        rows={series}
        modalFields={newModalField}
        initialFormData={{
          codigo: "",
          descripcion: "",
          fecha_creacion: moment(),
        }}
        onSaveModal={handleSaveNewSerie}
        onActivate={onActivate}
        onInactivate={onInactivate}
        enableActivate
        //onUpdate={onUpdate}
        enableUpdate={false}
        enableDocumentarytype={false}
        enableView={false}
        requiredFields={requiredFields}
        loadList={listSeries}
        rowCount={rowCount}
        pageSize={pageSize}
        page={page}
        handlePageChange={handlePageChange}
        handlePageSizeChange={handlePageSizeChange}
      />
    </>
  );
}
